import React from 'react';
import { BookOpen, Users } from 'lucide-react';

interface RoleSelectorProps {
  onSelect: (role: 'reader' | 'author') => void;
}

export default function RoleSelector({ onSelect }: RoleSelectorProps) {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-4">
      <h1 className="text-6xl font-bold mb-8 text-center"
          style={{ 
            background: `linear-gradient(135deg, var(--color-accent1), var(--color-accent2))`,
            WebkitBackgroundClip: 'text'
          }}>
        Welcome to StoryMuse
      </h1>
      
      <p className="text-xl mb-12 text-center max-w-2xl" style={{ color: 'var(--color-accent2)' }}>
        Choose your role to get started with a personalized experience
      </p>

      <div className="grid md:grid-cols-2 gap-8 max-w-4xl w-full">
        <button
          onClick={() => onSelect('reader')}
          className="group p-8 rounded-2xl transition-transform hover:scale-105 text-left"
          style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}
        >
          <Users className="w-12 h-12 mb-4" style={{ color: 'var(--color-accent1)' }} />
          <h2 className="text-2xl font-bold mb-2" style={{ color: 'var(--color-font)' }}>
            I'm a Reader
          </h2>
          <p style={{ color: 'var(--color-font)' }}>
            Discover exciting new stories, vote on your favorites, and help shape the future of storytelling.
            Join our community of passionate readers.
          </p>
        </button>

        <button
          onClick={() => onSelect('author')}
          className="group p-8 rounded-2xl transition-transform hover:scale-105 text-left"
          style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}
        >
          <BookOpen className="w-12 h-12 mb-4" style={{ color: 'var(--color-accent1)' }} />
          <h2 className="text-2xl font-bold mb-2" style={{ color: 'var(--color-font)' }}>
            I'm an Author
          </h2>
          <p style={{ color: 'var(--color-font)' }}>
            Share your book ideas, get valuable feedback, and build an audience before you write.
            Connect with engaged readers who love your genre.
          </p>
        </button>
      </div>
    </div>
  );
}